export interface ICallInfo {
  leadName: string;
  contactPersonName: string;
  mobileNumber: string;
}
export enum CallType {
  INCOMING_TYPE = "Incoming",
  OUTGOING_TYPE = "Outgoing",
  MISSED_TYPE = "Missed",
}

export interface ICallLog {
  remark: string;
  callDate: string;
  duration: string;
  endTime: string;
  number?: string;
  startTime: string;
  type: CallType;
  wasPickedUp: boolean;
  leadId: string;
  _id?: string;
}
